const citiesName = [
  ['Amsterdam', 'Амстердам'],
  ['Angora', 'Ангора'],
  ['Athina', 'Афины'],
  ['Barcelona', 'Барселона'],
  ['Berlin', 'Берлин'],
  ['Brest', 'Брест'],
  ['Brindisi', 'Бриндизи'],
  ['Bruxelles', 'Брюссель'],
  ['Bucuresti', 'Бухарест'],
  ['Budapest', 'Будапешт'],
  ['Cadiz', 'Кадикс'],
  ['Constantinople', 'Константинополь'],
  ['Danzig', 'Данциг'],
  ['Dieppe', 'Дьепп'],
  ['Edinburgh', 'Эдинбург'],
  ['Erzurum', 'Эрзерум'],
  ['Essen', 'Эссен'],
  ['Frankfurt', 'Франкфурт'],
  ['Kharkov', 'Харьков'],
  ['Kobenhavn', 'Копенгаген'],
  ['Kyiv', 'Киев'],
  ['Lisboa', 'Лиссабон'],
  ['London', 'Лондон'],
  ['Madrid', 'Мадрид'],
  ['Marseille', 'Марсель'],
  ['Moskva', 'Москва'],
  ['Munchen', 'Мюнхен'],
  ['Palermo', 'Палермо'],
  ['Pamplona', 'Памплона'],
  ['Paris', 'Париж'],
  ['Petrograd', 'Петроград'],
  ['Riga', 'Рига'],
  ['Roma', 'Рим'],
  ['Rostov', 'Ростов'],
  ['Sarajevo', 'Сараево'],
  ['Sevastopol', 'Севастополь'],
  ['Smolensk', 'Смоленск'],
  ['Smyrna', 'Смирна'],
  ['Sochi', 'Сочи'],
  ['Sofia', 'София'],
  ['Stockholm', 'Стокгольм'],
  ['Venezia', 'Венеция'],
  ['Warszawa', 'Варшава'],
  ['Wien', 'Вена'],
  ['Wilno', 'Вильно'],
  ['Zagrab', 'Загреб'],
  ['Zurich', 'Цюрих'],
];

export default citiesName;
